export default {
  table: {
    date: 'Fecha de creación',
    type: 'Tipo de archivo',
    name: 'Nombre',
    description: 'Descripción',
    title: 'Nuevo archivo'
  }
}
